var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCaedanLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 67.41 64.87",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#4affab;}.cls-2{fill:#22b573;}.cls-3{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    "data-name": "Layer 3"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "33.7 25.95 44.94 19.46 44.94 45.41 67.41 32.43 67.41 45.41 33.7 64.87 33.7 25.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "56.17 25.95 67.41 32.43 44.94 45.41 44.94 32.43 56.17 25.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "0 6.49 33.7 25.95 33.7 64.87 0 45.41 0 32.43 22.47 45.41 22.47 32.43 0 19.46 0 6.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "0 32.43 11.23 25.95 22.47 32.43 22.47 45.41 0 32.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "0 6.49 11.23 0 44.94 19.46 33.7 25.95 0 6.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "0 6.49 11.23 0 44.94 19.46 44.94 32.43 56.17 25.95 67.41 32.43 67.41 45.41 33.7 64.87 0 45.41 0 32.43 11.23 25.95 0 19.46 0 6.49"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "0 6.49 33.7 25.95 44.94 19.46"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "11.23 25.95 22.47 32.43 22.47 45.41 0 32.43"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 33.7,
    y1: 25.95,
    x2: 33.7,
    y2: 64.87
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "44.94 32.43 44.94 45.41 67.41 32.43"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaedanLogo);
export default __webpack_public_path__ + "static/media/caedan-logo.6e6f2b3a.svg";
export { ForwardRef as ReactComponent };